import styled from 'styled-components';

export const BottomNavList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 818px;
  padding: 0;
  margin: 0 auto;
  list-style: none;

  &.completed > li:nth-child(1) {
    color: #222228;
    &:before {
      background-color: #42C4F1;
    }
  }
  &.completed > li:nth-child(2) {
    color: #222228;
    &:before {
      background-color: #00B08C;
    }
  }
  &.completed > li:nth-child(3) {
    color: #222228;
    &:before {
      background-color: #E9CF51;
    }
  }
  &.completed > li:nth-child(4) {
    color: #222228;
    &:before {
      background-color: #FB9D5E;
    }
  }
  &.completed > li:nth-child(5) {
    color: #222228;
    &:before {
      background-color: #EA5323;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Auth0Animation/components/BottomNav/styled.js